import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../config.js';
import UserContext from '../components/common/UserContext.js';

// components
import Spinner from '../components/common/Spinner.js';
import PageHeader from '../components/common/PageHeader.js';
import UsersGrid from '../components/Users/UsersGrid.js';
import {useSupportContext} from "../components/common/SupportContext";

import {Text} from '../components/common/MultilingualText.js';
import {
    manageUsersKey,
    myUsersKey,
    mainMessages
} from '../assets/text/MultilingualText.js';

function Users() {
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const { dispatch } = useSupportContext();

    const [isLoading, setIsLoading] = useState(false);

    const [users, setUsers] = useState([]);
    /*
    * getUsers() gets all ea users
   */
    const getUsers = () => {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };

        setIsLoading(true);

        axios.get(
            `${config.users.USERS}`,
            {headers: headers}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data || [];
                    setUsers(data);
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to GET EA Users", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    // initialize ea users grid
    useEffect(() => {
        getUsers();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Support Context Metadata
    // Set Module and Step values on page load
    useEffect(() => {
        dispatch({ type: 'MODULE_LOAD', payload: {module: 'EA Users', step: ''}});
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {isLoading ? <Spinner/> : <></>}
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <div className={"k-h3"}>
                    <Text
                        textkey={manageUsersKey}
                        textdefault={mainMessages[siteLanguageDefault][manageUsersKey]}
                    />
                </div>
                <div
                    className={'k-mb-2'}
                    style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        alignItems: 'end',
                    }}
                >
                    <div
                        style={{marginBottom: "0"}}
                        className={"k-h5"}
                    >
                        <Text
                            textkey={myUsersKey}
                            textdefault={mainMessages[siteLanguageDefault][myUsersKey]}
                        />
                    </div>
                </div>
                <div>
                    <UsersGrid
                        users={users}
                        getUsers={getUsers}
                        setIsLoading={setIsLoading}
                    />
                </div>
            </div>
        </>
    );
}

export default Users;
